import React, { useEffect, useRef, useState } from 'react';
import styles from './StatsBar.module.css';

const STATS = [
  { num: '100+', label: 'Fortune Companies Served' },
  { num: '5',    label: 'Core Service Verticals'   },
  { num: '10+',  label: 'IT Courses Offered'       },
  { num: '2',    label: 'Countries · India & USA'  },
];

function Stat({ num, label }) {
  const [target, suffix] = [parseInt(num, 10), num.replace(/^\d+/, '')];
  const [value, setValue] = useState(0);
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    let raf;
    let started = false;
    const start = () => {
      if (started) return;
      started = true;
      const duration = 1200;
      let startTime = null;
      const step = (ts) => {
        if (startTime === null) startTime = ts;
        const progress = Math.min((ts - startTime) / duration, 1);
        setValue(Math.floor(progress * target));
        if (progress < 1) raf = requestAnimationFrame(step);
      };
      raf = requestAnimationFrame(step);
    };

    if (typeof IntersectionObserver === 'undefined') {
      start();
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        observer.disconnect();
        start();
      },
      { threshold: 0.4 }
    );
    observer.observe(el);

    // Safety net: renderers that never dispatch real scroll events (crawlers,
    // print-to-PDF, screenshot tools) would otherwise leave this stuck at 0.
    const fallback = setTimeout(start, 2500);

    return () => {
      observer.disconnect();
      clearTimeout(fallback);
      cancelAnimationFrame(raf);
    };
  }, [target]);

  return (
    <div className={styles.stat} ref={ref}>
      <div className={styles.num}>{value}{suffix}</div>
      <div className={styles.label}>{label}</div>
    </div>
  );
}

export default function StatsBar() {
  return (
    <div className={styles.bar}>
      {STATS.map((s, i) => (
        <Stat key={i} num={s.num} label={s.label} />
      ))}
    </div>
  );
}
